export default "__VITE_ASSET__DfPTvI_F__"